import type { BoxProps, TextProps } from '@chakra-ui/react';
import { Box } from '@chakra-ui/react';
import { forwardRef } from 'react';

export type GradientTextProps = BoxProps & { gradient: TextProps['bgColor'] };

export const GradientText = forwardRef<HTMLParagraphElement, GradientTextProps>(
  (props, ref) => {
    const { gradient, ...textProps } = props;

    return (
      <Box
        className="gradient-text"
        bg={gradient}
        bgClip="text"
        ref={ref}
        {...textProps}
      />
    );
  },
);

// eslint-disable-next-line @ts-intl/ts-intl/no-raw-text
GradientText.displayName = 'GradientText';
